import { vceFirestore } from "../../configs/FirebaseConfig";
import { FIRESTORE_PICK_DAY_LOCKS_TABLE } from "../../constants/FirestoreConstant";

/**
 * Whether a delivery date is locked because its pick day was released (pickDayLocks, written by
 * usePickDays.release). Read from VCE, where the lock is always written; HVO holds a mirror for
 * its own security rules.
 *
 * This is the friendly layer - a clear message instead of a refused save. The real lock is the
 * security rules (fulfilment-cms/firebase/firestore.rules), which refuse the write itself.
 *
 * @returns {Promise<{ locked: boolean, lock: Object|null }>} rejects when the read fails
 */
export const readDeliveryDateLock = async (deliveryDate) => {
  if (!deliveryDate) return { locked: false, lock: null };
  const snapshot = await vceFirestore.collection(FIRESTORE_PICK_DAY_LOCKS_TABLE).doc(deliveryDate).get();
  return snapshot.exists ? { locked: true, lock: snapshot.data() } : { locked: false, lock: null };
};
